import { makeStyles } from '@material-ui/core'
import React from 'react'
import { tokens } from './tokens'
import { Container } from './Container'
import { SectionTitle } from './SectionTitle'

const svgProps = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '1.6', strokeLinecap: 'round', strokeLinejoin: 'round' }

const CATEGORIES = [
    {
        title: 'Flashing Test Fixtures',
        icon: (
            <i class="fa-solid fa-screwdriver-wrench"></i>
        ),
    },
    {
        title: 'ATE Manufacturer',
        icon: (
            <i class="fa-solid fa-gears"></i>
        ),
    },
    {
        title: 'In-Circuit Test',
        icon: (
            <i class="fa-solid fa-microchip"></i>
        ),
    },
    {
        title: 'Manual Test Fixtures',
        icon: (
            <i class="fa-solid fa-memory"></i>
        ),
    },
    {
        title: 'Functional Test Fixture',
        icon: (
            <i class="fa-solid fa-arrow-right-arrow-left"></i>
        ),
    },
    {
        title: 'Our Capabilities',
        icon: (
            <i class="fa-solid fa-people-group"></i>
        ),
    },
]

const useStyles = makeStyles(() => ({
    section: { background: tokens.colorPrimaryLight, padding: '80px 0' },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 26,
        '@media (max-width: 860px)': { gridTemplateColumns: '1fr' },
    },
    card: {
        background: '#fff',
        borderRadius: tokens.radiusMd,
        padding: '44px 24px',
        textAlign: 'center',
        boxShadow: tokens.shadowMd,
        transition: `transform ${tokens.transition}, box-shadow ${tokens.transition}, background ${tokens.transition}`,
        '&:hover, &:focus-within': {
            background: tokens.colorPrimary,
            transform: 'translateY(-6px)',
            boxShadow: '0 20px 40px rgba(24,42,195,0.3)',
            '& $icon, & $title': { color: '#fff' },
        },
    },
    icon: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 56, height: 56,
        marginBottom: 18,
        color: tokens.colorBlack,
        transition: `color ${tokens.transition}`,
        '& i': {fontSize: '2.4rem', },
    },
    title: {
        fontSize: '1.05rem',
        transition: `color ${tokens.transition}`,
        margin: 0,
        color: tokens.colorBlack,
        fontFamily: tokens.fontBody,
        fontWeight: 700,
    },
}))

export function Categories() {
    const classes = useStyles()
    return (
        <section className={classes.section} id="categories">
            <Container>
                <SectionTitle>Product Categories Overview</SectionTitle>
                <div className={classes.grid}>
                    {CATEGORIES.map((c) => (
                        <div className={classes.card} key={c.title}>
                            <span className={classes.icon} aria-hidden="true">{c.icon}</span>
                            <h3 className={classes.title}>{c.title}</h3>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    )
}
